import { Button, Heading, Text } from '@react-spectrum/s2';
import { style as spectrumStyle } from '@react-spectrum/s2/style' with { type: 'macro' };

import { SuccessCheckBadge } from '@/components/SuccessCheckBadge';

type QuietSuccessInterstitialAction = {
	label: string;
	onPress: () => void;
};

type QuietSuccessInterstitialProps = {
	title: string;
	summary: string;
	primaryAction: QuietSuccessInterstitialAction;
	secondaryAction?: QuietSuccessInterstitialAction;
};

export const QuietSuccessInterstitial = ({
	title,
	summary,
	primaryAction,
	secondaryAction,
}: QuietSuccessInterstitialProps) => {
	return (
		<div className="flex h-full w-full items-center justify-center">
			<div
				className="flex flex-col items-center px-8 text-center"
				style={{ maxWidth: 480 }}
			>
				<div className="mb-5">
					<SuccessCheckBadge />
				</div>

				<Heading
					level={2}
					styles={spectrumStyle({
						font: 'heading',
						fontSize: 'heading',
						fontWeight: 'bold',
					})}
					UNSAFE_className="mb-3"
				>
					{title}
				</Heading>

				<Text
					styles={spectrumStyle({
						font: 'body',
						fontSize: 'body-sm',
						color: 'body',
					})}
					UNSAFE_className="mb-8"
				>
					{summary}
				</Text>

				<div className="flex items-center gap-3">
					{secondaryAction && (
						<Button variant="secondary" onPress={secondaryAction.onPress}>
							{secondaryAction.label}
						</Button>
					)}
					<Button variant="accent" onPress={primaryAction.onPress}>
						{primaryAction.label}
					</Button>
				</div>
			</div>
		</div>
	);
};
